import type { IService } from 'restangular'

import { app } from '../../app.module'

/**
 * 大カテゴリを複数選択するフォーム
 * attribute: {array} selected-val 選択された大カテゴリ
 */
class BrandCategoryMultiFormComponentCtrl {
  private scope: ng.IScope
  private selectedVal: {}
  private restangular: IService
  private categories: string[]

  constructor($scope, Restangular) {
    this.scope = $scope
    this.restangular = Restangular
    this.categories = []
    // 大カテゴリ一覧をサーバーから取得する
    this.setCategory()
  }

  /**
   * 選択したカテゴリー一覧のデータをイベント送信する
   */
  public selectCategory() {
    this.scope.$emit('setCategoryAccessControl', this.selectedVal)
  }

  /**
   * 大カテゴリ一覧を取得し、選択項目としてセットする
   */
  private setCategory() {
    const request = this.restangular.all('brand_category/getAllBrandCategory?is_pro=true').getList()

    request.then((response) => {
      // カテゴリ名のみを配列に格納する
      this.categories = response[0].data.map((category) => {
        return category.brandCategoryName
      })
    })
  }
}

app.component('brandCategoryMultiForm', {
  bindings: {
    selectedVal: '<',
  },
  template: require('./brand-category-multi-form.pug')(),
  controller: BrandCategoryMultiFormComponentCtrl,
})
